export default __webpack_public_path__ + "static/media/us_letter_landscape.f5060c5d.png";